@if (showHeader) {
    <app-header [showMenu]="true"></app-header>
}
@if (showBack) {
    <a mat-button class="goBack fade-in" (click)="goBack()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        {{ 'account.back' | transloco }}
    </a>
}
<br/>
<!--<app-video-link *ngIf="showHeader" class="pull-right" videoLink="/help/download"></app-video-link>-->
<span style="padding: 30px; font-size: 2em">
  <mat-icon style="position: relative; top: 5px">download</mat-icon>
    {{ headerText1 }}
</span>
<br/>
<span style="padding: 30px; font-size: 1em">
  {{ headerText2 }}
</span>
<br/>
<br/>
@if (showPlayer) {
    <div class="tab-buttons">
        <button mat-raised-button class="tab-button" [class.active]="tabIndex === 0" (click)="go('0')">
            <mat-icon>edit</mat-icon>
            <span>{{ 'account.studio' | transloco }}</span>
        </button>
        <button mat-raised-button class="tab-button" [class.active]="tabIndex === 1" (click)="go('1')">
            <mat-icon>tv</mat-icon>
            <span>{{ 'account.player' | transloco }}</span>
        </button>
    </div>
}
<ngx-flicking [options]="{ circular: false, duration: 800, autoResize: true }" [plugins]="plugins">
    <div flicking-panel class="panel">
        <br/>
        <br/>
        <app-studio-download></app-studio-download>
    </div>
    <div flicking-panel class="panel">
        <br/>
        <div class="form-main">
            <!-- Hero Section -->
            <div class="hero-section">
                <div class="hero-icon">
                    <mat-icon>tv</mat-icon>
                </div>
                <h1 class="hero-title">SignPlayer</h1>
                <p class="hero-subtitle">Digital Signage Player</p>
            </div>

            <!-- PRIMARY: Main Download Button -->
            <div class="main-download-section">
                <button mat-raised-button color="warn" class="downloadMainBut" (click)="download('player_sign_chrome')">
                    <mat-icon class="download-icon">download</mat-icon>
                    <span class="main-text">Download now</span>
                    <div class="os-row">
                        <div class="os-item"><mat-icon>desktop_windows</mat-icon><span>Windows</span></div>
                        <div class="os-item"><mat-icon>laptop_mac</mat-icon><span>Mac</span></div>
                        <div class="os-item"><mat-icon>computer</mat-icon><span>Linux</span></div>
                        <div class="os-item"><mat-icon>android</mat-icon><span>Android</span></div>
                        <div class="os-item"><mat-icon>phone_iphone</mat-icon><span>iOS</span></div>
                        <div class="os-item"><mat-icon>developer_board</mat-icon><span>Raspberry Pi</span></div>
                    </div>
                </button>
            </div>

            <!-- PRIMARY: Hardware Option -->
            <div class="hardware-section">
                <div class="hardware-card" (click)="download('mediadroid')">
                    <div class="hardware-badge">Or get Hardware and software | Plug & play</div>
                    <mat-icon style="position: relative; top: -20px" class="hardware-icon">router</mat-icon>
                    <div class="hardware-content">
                        <h4>mediaDROID+</h4>
                        <p>Pre configured hardware player</p>
                        <span class="hardware-cta" style="position: relative; left: -10px">
                            <fa-icon [icon]="faAmazon" style="font-size: 0.8em"></fa-icon>
                            <span style="position: relative; left: -6px">Order on Amazon</span>
                        </span>
                    </div>
                    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                </div>
            </div>

            <!-- SECONDARY: Advanced Options Toggle -->
            <button mat-stroked-button class="advanced-toggle-btn" (click)="toggleAdvancedOptions()">
                <mat-icon>{{ showAdvancedOptions ? 'expand_less' : 'expand_more' }}</mat-icon>
                <span>{{ showAdvancedOptions ? 'Hide' : 'Show' }} Advanced Options</span>
            </button>

            <!-- SECONDARY: Advanced Options Section -->
            @if (showAdvancedOptions) {
            <div class="advanced-section">
                <!-- TV Installation Guide -->
                <div class="advanced-card" (click)="download('device_compatability')">
                    <mat-icon class="advanced-icon">live_tv</mat-icon>
                    <div class="advanced-content">
                        <h4>Custom Installation Guide</h4>
                        <p>For Google TV, Fire TV and others</p>
                    </div>
                    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                </div>

                <!-- SignService Section -->
                <div class="service-section">
                    <div class="service-header">
                        <mat-icon>settings</mat-icon>
                        <div>
                            <h4>SignService</h4>
                            <p>Auto start and watchdog for SignPlayer</p>
                        </div>
                    </div>

                    <div class="service-cards-compact">
                        <div class="service-card-sm" (click)="openAndroidModal()">
                            <mat-icon class="android-icon">android</mat-icon>
                            <span>Android</span>
                        </div>

                        <div class="service-card-sm" (click)="openWindowsModal()">
                            <mat-icon class="windows-icon">desktop_windows</mat-icon>
                            <span>Windows</span>
                        </div>

                        <div class="service-card-sm" (click)="openLinuxModal()">
                            <mat-icon class="linux-icon">computer</mat-icon>
                            <span>Linux</span>
                        </div>

                        <div class="service-card-sm" (click)="openRaspberryPiModal()">
                            <mat-icon class="raspberry-icon">developer_board</mat-icon>
                            <span>Raspberry Pi</span>
                        </div>
                    </div>

                    <div class="service-note">
                        <mat-icon>info_outline</mat-icon>
                        <span>SignService can be downloaded from SignPlayer's Info Box (Gear icon) found in the sidebar</span>
                    </div>
                </div>

                <!-- Legacy Toggle -->
                <button mat-stroked-button class="legacy-toggle-btn" (click)="toggleLegacyDownloads()">
                    <mat-icon>{{ showLegacyDownloads ? 'expand_less' : 'expand_more' }}</mat-icon>
                    <span>{{ showLegacyDownloads ? 'Hide' : 'Show' }} Legacy Versions</span>
                </button>

                <!-- TERTIARY: Legacy Downloads Section -->
                @if (showLegacyDownloads) {
                <div class="legacy-section">
                    <div class="legacy-header">
                        <mat-icon>history</mat-icon>
                        <h3>Legacy Versions</h3>
                        <span class="deprecated-badge">Deprecated</span>
                    </div>

                    <div class="legacy-downloads">
                        <div class="legacy-card" (click)="download('player_exe')">
                            <mat-icon class="platform-icon">desktop_windows</mat-icon>
                            <div class="legacy-content">
                                <h4>SignagePlayer.exe</h4>
                                <p>Windows 32 and 64 bit</p>
                            </div>
                            <mat-icon class="download-icon">download</mat-icon>
                        </div>

                        <div class="legacy-card" (click)="download('player_legacy_apk')">
                            <mat-icon class="platform-icon">android</mat-icon>
                            <div class="legacy-content">
                                <h4>SignagePlayer.apk v1</h4>
                                <p>Legacy ADX and older Android</p>
                            </div>
                            <mat-icon class="download-icon">download</mat-icon>
                        </div>

                        <div class="legacy-card" (click)="download('player_android_watchdog_v2')">
                            <mat-icon class="platform-icon">android</mat-icon>
                            <div class="legacy-content">
                                <h4>Android Watchdog v2</h4>
                                <p>For ADZ and Android 9.X and later</p>
                            </div>
                            <mat-icon class="download-icon">download</mat-icon>
                        </div>

                        <div class="legacy-card" (click)="download('player_android_watchdog_v1')">
                            <mat-icon class="platform-icon">android</mat-icon>
                            <div class="legacy-content">
                                <h4>Android Watchdog v1</h4>
                                <p>Legacy SignagePlayer and ADX</p>
                            </div>
                            <mat-icon class="download-icon">download</mat-icon>
                        </div>

                        <div class="legacy-card" (click)="download('player_air')">
                            <mat-icon class="platform-icon">laptop_mac</mat-icon>
                            <div class="legacy-content">
                                <h4>SignagePlayer.air</h4>
                                <p>Mac OSX 32 bit requires AIR</p>
                            </div>
                            <mat-icon class="download-icon">download</mat-icon>
                        </div>

                        <div class="legacy-card" (click)="download('player_air')">
                            <mat-icon class="platform-icon">desktop_windows</mat-icon>
                            <div class="legacy-content">
                                <h4>SignagePlayer.air</h4>
                                <p>Windows 32 and 64 bit requires AIR</p>
                            </div>
                            <mat-icon class="download-icon">download</mat-icon>
                        </div>

                        <div class="legacy-card" (click)="download('player_linux')">
                            <mat-icon class="platform-icon">computer</mat-icon>
                            <div class="legacy-content">
                                <h4>SignagePlayer for Linux</h4>
                                <p>Deprecated with limited support</p>
                            </div>
                            <mat-icon class="download-icon">download</mat-icon>
                        </div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
    </div>
</ngx-flicking>
<ng-template let-modal #installModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">android</mat-icon>
        <span class="section-title">{{ 'ai.manual' | transloco }} {{ 'ai.installation' | transloco }} {{ 'ai.for' | transloco }} Android</span>
        <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-raised-button (click)="download('mediadroid')" style="padding: 10px; margin: 20px; width: 100%" color="warn">
                <mat-icon class="hide-lt-md">star</mat-icon>
                for best performance & reliability get the mediaDROID+
            </button>
        </div>
        <div class="compat">
            <div>
                <div>
                    <br/>
                    <mat-label class="minHead">🚀 Direct installation of SignPlayer on Android with no Preinstalled Chrome on the device such as Google TV and Fire TV</mat-label>
                    <hr/>
                    <div class="installation-steps">
                        <ol style="line-height: 1.8; margin: 20px 0;">
                            <li>
                                📱 Download and install Chrome from <a href="https://play.google.com/store/apps/details?id=com.android.chrome" target="_blank" class="linkGoToDownload hover-link">Google Play Store</a> or get the APK from <a href="https://www.apkmirror.com/apk/google-inc/chrome/" target="_blank" class="linkGoToDownload hover-link">https://www.apkmirror.com/apk/google-inc/chrome/</a>.
                                <br/><small style="opacity: 0.8;">Make sure to choose arm64-v8a + armeabi-v7a architecture and its an APK and not BUNDLE<br/>
                                (Last tested on Google Chrome 138.0.7204.168 (arm64-v8a + armeabi-v7a) (Android 9.0+))</small>
                            </li>
                            <li>
                                ⬇️ Download and install SignService from <a href="https://galaxy.signage.me/deploy/android/signService.apk" target="_blank" class="linkGoToDownload hover-link">https://galaxy.signage.me/deploy/android/signService.apk</a>
                            </li>
                            <li>
                                ✅ On launch, click each check list item's Allow button to enable permissions.<br/>
                                <small style="opacity: 0.8;">Note that not all permissions is available on all devices - check the Dialog box and see Note if said permission is applicable for the device you are installing.</small>
                            </li>
                            <li>
                                🌐 When done, click Start SignPlayer - Chrome will open and will show the install page. If you are asked which App to use and SignPlayer is not in the selection, choose Chrome then click Just Once.
                            </li>
                            <li>
                                📺 For Google TV and Fire TV, using the mouse, click on the SignPlayer link - this will install SignPlayer.
                            </li>
                            <li>
                                🔄 After SignPlayer is installed, restart the device.
                            </li>
                            <li>
                                🎯 On boot, SignService will kick and may ask which App to launch. Choose SignPlayer and this time choose Always.
                            </li>
                            <li>
                                ✨ Installation is complete. Register your player if you have not yet done so.
                            </li>
                        </ol>
                    </div>
                    <br/>
                </div>
            </div>
<!--            <div>-->
<!--                <fa-icon style="position:relative; top: 4px" size='lg' class="watchdog" [icon]="faAndroid"></fa-icon>-->
<!--                <span class="minHead">SignPlayer and watchdog are also compatible these Android devices:</span>-->
<!--                <hr/>-->
<!--                <ul class="">-->
<!--                    <li>Google TV</li>-->
<!--                    <li>Fire TV</li>-->
<!--                    <li>Android TV</li>-->
<!--                    <li>Android Car</li>-->
<!--                    <li>Google Chrome OS Flex</li>-->
<!--                    <li>Google Chromecast</li>-->
<!--                    <li>Microsoft Windows (latest)</li>-->
<!--                    <li>Apple Mac</li>-->
<!--                    <li>Linux (Ubuntu tested)</li>-->
<!--                    <li>Amazon Fire stick</li>-->
<!--                    <li>TCL TV</li>-->
<!--                    <li>Sony Bravia TV</li>-->
<!--                    <li>Samsung Android TV</li>-->
<!--                    <li>Nvidia Shield (latest)</li>-->
<!--                    <li>Raspberry PI</li>-->
<!--                    <li>iPad (check version with support)</li>-->
<!--                    <li>iPhone (check version with support)</li>-->
<!--                    <li>Browser / Web embedded</li>-->
<!--                </ul>-->
<!--            </div>-->
        </div>
    </div>
</ng-template>

<!-- Windows SignService Modal -->
<ng-template let-modal #windowsModal>
    <div class="service-dialog windows-theme">
        <div class="service-header">
            <div class="header-bg"></div>
            <button mat-icon-button class="close-btn" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
            <div class="header-content">
                <div class="service-logo">
                    <mat-icon>desktop_windows</mat-icon>
                </div>
                <div class="header-text">
                    <h1>SignService for Windows</h1>
                    <p class="subtitle">Watchdog and Auto Start Service</p>
                </div>
            </div>
        </div>

        <div mat-dialog-content class="service-body">
            <div class="service-grid">
                <div class="left-column">
                    <h3>What it does</h3>
                    <div class="feature-list">
                        <div class="feature-row">
                            <mat-icon>autorenew</mat-icon>
                            <span>Auto restart SignPlayer on crash</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>power_settings_new</mat-icon>
                            <span>Launch SignPlayer on Windows boot</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>visibility</mat-icon>
                            <span>Monitor player health status</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>security</mat-icon>
                            <span>Runs as Windows service</span>
                        </div>
                    </div>

                    <div class="requirements-card">
                        <h4>Requirements</h4>
                        <div class="req-tags">
                            <span class="req-tag">Windows 10 or later</span>
                            <span class="req-tag">64 bit</span>
                            <span class="req-tag">Chrome or Chromium browser</span>
                        </div>
                    </div>
                </div>

                <div class="right-column">
                    <div class="download-card">
                        <div class="download-icon">
                            <mat-icon>download</mat-icon>
                        </div>
                        <h4>Download SignService</h4>
                        <p>Windows Installer</p>
                        <button mat-raised-button color="primary" class="download-btn" (click)="download('player_windows_sign_watchdog')">
                            <mat-icon>download</mat-icon>
                            Download for Windows
                        </button>
                    </div>

                    <div class="install-steps">
                        <h4>Installation</h4>
                        <div class="mini-step">
                            <span class="step-num">1</span>
                            <span>Download and run installer</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">2</span>
                            <span>Follow setup wizard</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">3</span>
                            <span>Service starts automatically</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Android SignService Modal -->
<ng-template let-modal #androidModal>
    <div class="service-dialog android-theme">
        <div class="service-header">
            <div class="header-bg"></div>
            <button mat-icon-button class="close-btn" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
            <div class="header-content">
                <div class="service-logo">
                    <mat-icon>android</mat-icon>
                </div>
                <div class="header-text">
                    <h1>SignService for Android</h1>
                    <p class="subtitle">Watchdog and Auto Start App</p>
                </div>
            </div>
        </div>

        <div mat-dialog-content class="service-body">
            <div class="service-grid">
                <div class="left-column">
                    <h3>What it does</h3>
                    <div class="feature-list">
                        <div class="feature-row">
                            <mat-icon>autorenew</mat-icon>
                            <span>Auto restart SignPlayer on crash</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>power_settings_new</mat-icon>
                            <span>Launch SignPlayer on device boot</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>visibility</mat-icon>
                            <span>Monitor player health status</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>touch_app</mat-icon>
                            <span>Permission management helper</span>
                        </div>
                    </div>

                    <div class="requirements-card">
                        <h4>Compatible Devices</h4>
                        <div class="req-tags">
                            <span class="req-tag">Android 9 or later</span>
                            <span class="req-tag">Google TV</span>
                            <span class="req-tag">Fire TV</span>
                            <span class="req-tag">Android TV</span>
                            <span class="req-tag">Tablets</span>
                        </div>
                    </div>
                </div>

                <div class="right-column">
                    <div class="download-card">
                        <div class="download-icon">
                            <mat-icon>download</mat-icon>
                        </div>
                        <h4>Download SignService</h4>
                        <p>Android APK</p>
                        <button mat-raised-button color="primary" class="download-btn" (click)="download('player_android_sign_watchdog')">
                            <mat-icon>android</mat-icon>
                            Download APK
                        </button>
                    </div>

                    <div class="install-steps">
                        <h4>Installation</h4>
                        <div class="mini-step">
                            <span class="step-num">1</span>
                            <span>Enable unknown sources</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">2</span>
                            <span>Install the APK file</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">3</span>
                            <span>Grant requested permissions</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">4</span>
                            <span>Tap Start SignPlayer</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template let-modal #linuxModal>
    <div class="linux-dialog">
        <!-- Header with gradient -->
        <div class="linux-header">
            <div class="header-bg"></div>
            <button mat-icon-button class="close-btn" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
            <div class="header-content">
                <div class="linux-logo">
                    <mat-icon>terminal</mat-icon>
                </div>
                <div class="header-text">
                    <h1>SignService for Linux</h1>
                    <p class="subtitle">Already integrated into SignPlayer</p>
                </div>
            </div>
        </div>

        <!-- Main Content -->
        <div mat-dialog-content class="linux-body">
            <!-- Two Column Layout -->
            <div class="linux-grid">
                <!-- Left Column - Steps -->
                <div class="steps-column">
                    <h3>Quick Setup</h3>
                    <div class="step-card">
                        <div class="step-icon">
                            <mat-icon>settings</mat-icon>
                        </div>
                        <div class="step-text">
                            <span class="step-label">Step 1</span>
                            <p>Open the player sidebar and click the <strong>Gear icon</strong> to open the Info box</p>
                        </div>
                    </div>
                    <div class="step-connector"></div>
                    <div class="step-card">
                        <div class="step-icon">
                            <mat-icon>download</mat-icon>
                        </div>
                        <div class="step-text">
                            <span class="step-label">Step 2</span>
                            <p>Click the <strong>Download</strong> button</p>
                        </div>
                    </div>
                    <div class="step-connector"></div>
                    <div class="step-card">
                        <div class="step-icon">
                            <mat-icon>terminal</mat-icon>
                        </div>
                        <div class="step-text">
                            <span class="step-label">Step 3</span>
                            <p>Close player, open <strong>Terminal</strong> and go to the Downloads folder</p>
                        </div>
                    </div>
                    <div class="step-connector"></div>
                    <div class="step-card">
                        <div class="step-icon">
                            <mat-icon>code</mat-icon>
                        </div>
                        <div class="step-text">
                            <span class="step-label">Step 4</span>
                            <p>Execute <strong>sudo bash install.sh</strong></p>
                        </div>
                    </div>
                    <div class="step-connector"></div>
                    <div class="step-card active">
                        <div class="step-icon">
                            <mat-icon>check</mat-icon>
                        </div>
                        <div class="step-text">
                            <span class="step-label">Done</span>
                            <p>SignService is now installed</p>
                        </div>
                    </div>
                </div>

                <!-- Right Column - Info -->
                <div class="info-column">
                    <!-- Features -->
                    <div class="features-card">
                        <h4>Features</h4>
                        <div class="feature-row">
                            <mat-icon>autorenew</mat-icon>
                            <span>Auto restart on crash</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>power_settings_new</mat-icon>
                            <span>Launch on boot</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>visibility</mat-icon>
                            <span>Health monitoring</span>
                        </div>
                        <div class="feature-row">
                            <mat-icon>all_inclusive</mat-icon>
                            <span>24 7 reliability</span>
                        </div>
                    </div>

                    <!-- Supported Distros -->
                    <div class="distros-card">
                        <h4>Supported Distros</h4>
                        <div class="distro-tags">
                            <span class="distro-tag">Ubuntu</span>
                            <span class="distro-tag">Raspberry Pi OS</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- Raspberry Pi SignService Modal -->
<ng-template let-modal #raspberryPiModal>
    <div class="service-dialog raspberry-theme">
        <div class="service-header">
            <div class="header-bg"></div>
            <button mat-icon-button class="close-btn" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
            <div class="header-content">
                <div class="service-logo">
                    <mat-icon>developer_board</mat-icon>
                </div>
                <div class="header-text">
                    <h1>SignPlayer for Raspberry Pi</h1>
                    <p class="subtitle">Digital Signage on ARM</p>
                </div>
            </div>
        </div>

        <div mat-dialog-content class="service-body">
            <div class="service-grid">
                <div class="left-column">
                    <h3>Supported Models</h3>
                    <div class="feature-list">
                        <div class="feature-row">
                            <mat-icon>check_circle</mat-icon>
                            <span>Raspberry Pi 5</span>
                        </div>
                    </div>

                    <div class="requirements-card">
                        <h4>Requirements</h4>
                        <div class="req-tags">
                            <span class="req-tag">Raspberry Pi OS 64 bit</span>
                            <span class="req-tag">4GB RAM minimum</span>
                            <span class="req-tag">32GB SD Card</span>
                        </div>
                    </div>
                </div>

                <div class="right-column">
                    <div class="download-card">
                        <div class="download-icon">
                            <mat-icon>download</mat-icon>
                        </div>
                        <h4>Download SignPlayer</h4>
                        <p>For Raspberry Pi OS</p>
                        <button mat-raised-button color="primary" class="download-btn" (click)="download('player_sign_chrome')">
                            <mat-icon>download</mat-icon>
                            Download for Raspberry Pi
                        </button>
                    </div>

                    <div class="install-steps">
                        <h4>Installation</h4>
                        <div class="mini-step">
                            <span class="step-num">1</span>
                            <span>Install Raspberry Pi OS 64 bit</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">2</span>
                            <span>Open Chromium browser</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">3</span>
                            <span>Install SignPlayer PWA</span>
                        </div>
                        <div class="mini-step">
                            <span class="step-num">4</span>
                            <span>Enable SignService from settings</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
